import React from 'react'

import {
  ScrollView,
  Text,
  TouchableOpacity,
  View,
  StyleSheet
} from 'react-native'
import { colorPalette, globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../../components/home/HomeDetailsHeader'
import Card from '../../../components/shared/card/Card'
import { boardStyles } from '../../../static/styles/board'
import { Entypo } from '@expo/vector-icons'
import { Ionicons, AntDesign } from '@expo/vector-icons'
import { useTranslation } from 'react-i18next'

type CardProfileProps = {
  title: string
  subTilte?: string
  icon?: any
  action?: any
}

const PayrollDocuments = ({ navigation, route }) => {
  const CardProfile = ({
    title,
    subTilte,
    icon = '',
    action
  }: CardProfileProps): JSX.Element => {
    return (
      <TouchableOpacity
        onPress={action}
        style={[
          globalStyles.hDirection,
          globalStyles.hBetweenItems,
          globalStyles.vCenterItems,
          styles.CardProfile
        ]}
      >
        <View style={[globalStyles.hDirection, globalStyles.vCenterItems]}>
          {icon.length > 0 && (
            <AntDesign
              name={icon}
              size={22}
              color="black"
              style={[globalStyles.mr2]}
            />
          )}
          <View style={[globalStyles.vDirection]}>
            <Text
              style={[
                globalStyles.text,
                globalStyles.fwSemiBold,
                globalStyles.primaryTextColor
              ]}
            >
              {title}
            </Text>
            {subTilte && subTilte !== '' && (
              <Text
                style={[
                  globalStyles.text,
                  globalStyles.fs12,
                  globalStyles.primaryTextColor
                ]}
              >
                {subTilte}
              </Text>
            )}
          </View>
        </View>
        {true && (
          <View style={[globalStyles.relativePosition, globalStyles.rn6]}>
            <Entypo
              name={'chevron-right'}
              size={22}
              color={colorPalette.secondary}
            />
          </View>
        )}
      </TouchableOpacity>
    )
  }
  const { t } = useTranslation()
  return (
    <ScrollView>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader />
        </View>
        <View style={[globalStyles.vCenterItems]}>
          <Text
            style={[
              globalStyles.text,
              globalStyles.fwBold,
              globalStyles.fs30,
              globalStyles.whiteTextColor,
              globalStyles.textCenter
            ]}
          >
            {t('Payroll Documents')}
          </Text>
        </View>
      </View>
      <View style={[globalStyles.containerOverlap]}>
        <Card>
          <View style={[boardStyles.boardCategory]}>
            <Text
              style={[
                globalStyles.text,
                globalStyles.fwBold,
                globalStyles.whiteTextColor
              ]}
            >
              {t('Payroll Resources')}
            </Text>
          </View>
          <View>
            <CardProfile
              title={t('View All Paystub Details')}
              action={() => {
                navigation.navigate('PayCheckDetails')
              }}
            />
          </View>
          <View style={{ marginTop: 10 }}>
            <CardProfile
              title={t('View W-2')}
              action={() => {
                navigation.navigate('Vieww2 Forms')
              }}
            />
          </View>
          {/* <View style={{ marginTop: 10 }}>
            <CardProfile
              title={'View 1095-C'}
              subTilte="Employee Reported Health Insurance Offer & Coverage"
              action={() => {
                navigation.navigate('')
              }}
            />
          </View> */}
        </Card>
        {/* <Card>
          <View style={[boardStyles.boardCategory]}>
            <Text
              style={[
                globalStyles.text,
                globalStyles.fwBold,
                globalStyles.whiteTextColor
              ]}
            >
              Direct Deposit
            </Text>
          </View>
          <View style={{ marginTop: 10 }}>
            <CardProfile
              title={'Update Direct Deposit Form'}
              action={() => {
                navigation.navigate('UpdateDirectDeposit')
              }}
            />
          </View>
        </Card> */}
      </View>
    </ScrollView>
  )
}
const styles = StyleSheet.create({
  CardProfile: {
    backgroundColor: colorPalette.light,
    padding: 16,
    borderRadius: 8
  }
})
export default PayrollDocuments
